import React, { SelectHTMLAttributes } from "react";
import style from "../pages/login/login.module.css";
import verificationStyle from "../pages/verificationPage/verifcation.module.css";

type Props = {
  title: string;
  placeholder: string;
  isIcon?: boolean;
  icon?: string;
  value?: string;
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSuffixChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  type?: string;
  isName?: boolean;
  disabled?: boolean;
  sufixValue?: string;
  isRequired?: boolean;
};

const InputForm = ({
  title,
  placeholder,
  isIcon = false,
  icon = "fa fa-phone",
  value = '',
  onClick,
  onChange,
  onSuffixChange,
  type = "text",
  isName = false,
  disabled = false,
  sufixValue,
  isRequired = false

}: Props) => {
  return (
    <div className={`${style.loginMobileNumber}`}>
      {title}
      {isRequired && <span className="text-red-500">{' *'}</span>}
      {isName ? <div className={"d-flex"} >
        <div className={style.inputContainer}>
          <select className={`${verificationStyle.dropdownMenu} ${verificationStyle.salutationCss} md:w-16 lg:w-16 xl:w-16`} value={sufixValue} onChange={onSuffixChange} name="" id="">
            <option value="Mr."> Mr.</option>
            <option value="Miss">Miss</option>
            <option value="Mrs.">Mrs.</option>
          </select>
        </div>
        <div
          className={style.inputContainer}
          style={{width:'100%', backgroundColor: disabled ? '#c5c5c5' : '#fff'}}
        >
          {isIcon && <i className={icon} onClick={(e) => { onClick && onClick(e) }}></i>}
          <input
            type={type}
            placeholder={placeholder}
            style={{ backgroundColor: disabled ? '#c5c5c5' : '#fff' }}
            disabled={disabled}
            value={value}
            onChange={(e) => { onChange && onChange(e) }} />

        </div>
      </div> : (
        <div
          className={style.inputContainer}
        style={{ backgroundColor: disabled ? '#c5c5c5' : '#fff' }}
        >
          {isIcon && <i className={icon} onClick={(e) => { onClick && onClick(e) }}></i>}
          <input
            type={type}
            placeholder={placeholder}
            style={{ backgroundColor: disabled ? '#c5c5c5' : '#fff' }}
            disabled={disabled}
            value={value}
            onChange={(e) => { onChange && onChange(e) }} />

        </div>)}
    </div>
  );
};

export default InputForm;
